import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function uploadImage(file, endpoint) {
  const fd = new FormData();
  fd.append("file", file);
  const token = localStorage.getItem("cc_token");
  const { data } = await axios.post(`${API}${endpoint}`, fd, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data.url;
}

export async function uploadFile(file, endpoint) {
  const fd = new FormData();
  fd.append("file", file);
  const token = localStorage.getItem("cc_token");
  const { data } = await axios.post(`${API}${endpoint}`, fd, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

// Chunked upload for large files (bypasses the ~100MB edge body-size limit).
export async function uploadFileChunked(file, endpoint, onProgress) {
  const CHUNK = 5 * 1024 * 1024;
  const total = Math.ceil(file.size / CHUNK) || 1;
  const uploadId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const token = localStorage.getItem("cc_token");
  let last;
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK, Math.min(file.size, (i + 1) * CHUNK));
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("chunk_index", i);
    fd.append("total_chunks", total);
    fd.append("filename", file.name);
    fd.append("file", blob, file.name);
    const { data } = await axios.post(`${API}${endpoint}`, fd, {
      headers: { Authorization: `Bearer ${token}` },
    });
    last = data;
    if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
  }
  return last;
}

export default api;
